import { render, staticRenderFns } from "./NewStu.vue?vue&type=template&id=03702306&"
import script from "./NewStu.vue?vue&type=script&lang=js&"
export * from "./NewStu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports